<template>
    <comp-form title="标签" ref="comp_form" submit-api="/gateway/api/sycompany/pc/label/createLabel" edit-api="/gateway/api/sycompany/pc/label/updateLabel" detail-api="/gateway/api/sycompany/pc/label/getLabelById" id-key="labelById" :submit-before="onSubmitBefore" :data-before="onDataBefore" @on-submit="onReset">
        <template v-slot:form-box="data">
            <elem-form-item title="标签名称" name="labelName">
                <template v-slot:default="item">
                    <Input style="width:300px" v-model.trim="data.form.labelName" :placeholder="item.cfg.ph"></Input>
                </template>
            </elem-form-item>
            <elem-form-item title="排序" name="sort">
                <template v-slot:default="item">
                    <Input style="width:300px" type="number" v-model.trim="data.form.sort" :placeholder="item.cfg.ph"></Input>
                </template>
            </elem-form-item>
            <elem-form-item title="背景色" name="bgColor">
                <template v-slot:default="item">
                    <Input style="width:300px" v-model.trim="data.form.bgColor" :placeholder="item.cfg.ph || '例如：#FFFFFF 或 rgb(255,255,255)'"></Input>
                </template>
            </elem-form-item>
            <elem-form-item title="跳转链接" name="jumpUrl">
                <template v-slot:default="item">
                    <Input style="width:300px" v-model.trim="data.form.jumpUrl" :placeholder="item.cfg.ph || '例如：https://example.com'"></Input>
                </template>
            </elem-form-item>
            <!-- <elem-form-item title="类型" name="labelType">
                <template v-slot:default="item">
                    <RadioGroup v-model="data.form.parentId" type="button" button-style="solid">
                        <Radio label="1">随心购</Radio>
                        <Radio label="2">乐龄通</Radio>
                    </RadioGroup>
                </template>
            </elem-form-item> -->
            <elem-form-item title="标签图标" name="icon">
                <elem-upload :value="data.form.icon" @on-change="onChangeIcon"></elem-upload>
            </elem-form-item>
            <elem-form-item title="Banner" name="banners" column>
                <template v-slot:default>
                    <div class="banner-box">
                        <div class="banner-header">
                            <div class="banner-tip">多组配置，每组包含图片与跳转链接</div>
                            <Button class="banner-add" type="primary" icon="ios-add" size="small" @click="onAddBanner(data.form)">新增一组</Button>
                        </div>

                        <div class="banner-empty" v-if="!(data.form.banners && data.form.banners.length)">暂无 Banner，请先新增一组</div>

                        <div class="banner-list" v-else>
                            <div v-for="(b, idx) in data.form.banners" :key="'banner-' + idx" class="banner-item">
                                <div class="banner-index">{{ idx + 1 }}</div>
                                <div class="banner-upload">
                                    <elem-upload :value="b.imgUrl" :concise="true" @on-change="e => onChangeBannerImg(data.form, idx, e)"></elem-upload>
                                </div>
                                <div class="banner-link">
                                    <Input v-model.trim="b.linkUrl" placeholder="请输入链接"></Input>
                                </div>
                                <div class="banner-actions">
                                    <Button type="error" size="small" ghost @click="onRemoveBanner(data.form, idx)">删除</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </elem-form-item>
        </template>
    </comp-form>
</template>

<script>
import CompForm from "../components/CompForm.vue"
import ElemUpload from "../components/elem-upload.vue"
import ElemFormItem from "../components/elem-form-item.vue"

export default {
    components: { CompForm, ElemUpload, ElemFormItem },

    methods: {
        /**
         * 打开表单窗口
         */
        open(id) {
            this.$refs.comp_form.open(id)
        },

        /**
         * 重置事件
         */
        onReset() {
            this.$emit("on-reset")
        },

        /**
         * 提交数据前置事件
         */
        onSubmitBefore(data) {
            data.oemCode = parent.vue.oemInfo.oemCode
            data.labelType = ""
            data.parentId = 0
            try {
                const ext = {}
                if (data.bgColor) ext.bgColor = data.bgColor
                if (data.jumpUrl) ext.jumpUrl = data.jumpUrl
                if (data.banners && data.banners instanceof Array) {
                    const banners = []

                    for (let i = 0; i < data.banners.length; i++) {
                        const b = data.banners[i] || {}
                        const imgUrl = (b.imgUrl || "").trim?.() || b.imgUrl
                        const linkUrl = (b.linkUrl || "").trim?.() || b.linkUrl

                        if (!imgUrl && !linkUrl) {
                            continue
                        }

                        if (!imgUrl || !linkUrl) {
                            this.$Message.error({
                                content: "Banner 每一组需要同时填写图片和链接",
                                background: true,
                            })
                            return false
                        }

                        banners.push({ imgUrl, linkUrl })
                    }

                    if (banners.length > 0) {
                        ext.banners = banners
                    }
                }
                data.extInfo = Object.keys(ext).length ? JSON.stringify(ext) : null
            } catch (e) {
                data.extInfo = null
            }
            // 可根据后端要求移除表单中的临时字段
            // delete data.bgColor
            // delete data.jumpUrl
            return data
        },

        onDataBefore(d) {
            const data = { ...(d || {}) }
            if (data && typeof data.extInfo === "string") {
                try {
                    const ext = JSON.parse(data.extInfo || '{}')
                    if (ext && typeof ext === 'object') {
                        data.bgColor = ext.bgColor || data.bgColor
                        data.jumpUrl = ext.jumpUrl || data.jumpUrl
                        if (ext.banners && ext.banners instanceof Array) {
                            data.banners = ext.banners
                        }
                    }
                } catch (e) {
                    // ignore parse error
                }
            }
            return data
        },

        onChangeIcon(e) {
            const url = typeof e.value === "string" ? e.value : e.value?.url
            this.$refs.comp_form.setValue("icon", url)
        },

        onAddBanner(form) {
            const banners = (form && form.banners instanceof Array ? form.banners : [])
            banners.push({ imgUrl: "", linkUrl: "" })
            this.$refs.comp_form.setValue("banners", banners)
        },

        onRemoveBanner(form, idx) {
            if (!form || !(form.banners instanceof Array)) return
            form.banners.splice(idx, 1)
            this.$refs.comp_form.setValue("banners", form.banners)
        },

        onChangeBannerImg(form, idx, e) {
            if (!form || !(form.banners instanceof Array)) return
            if (!form.banners[idx]) this.$set(form.banners, idx, { imgUrl: "", linkUrl: "" })
            const url = typeof e.value === "string" ? e.value : e.value?.url
            this.$set(form.banners[idx], "imgUrl", url)
            this.$refs.comp_form.setValue("banners", form.banners)
        },
    },
}
</script>

<style lang="less" scoped>
.banner-box {
    width: 100%;
}

.banner-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    border: 1px solid #e8eaec;
    border-radius: 6px;
    background: #fafafa;
}

.banner-tip {
    font-size: 12px;
    color: #808695;
}

.banner-empty {
    margin-top: 10px;
    padding: 14px 12px;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
    color: #909399;
    background: #fff;
}

.banner-list {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.banner-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border: 1px solid #e8eaec;
    border-radius: 8px;
    background: #fff;
}

.banner-index {
    width: 28px;
    height: 28px;
    border-radius: 14px;
    background: #f0f2f5;
    color: #515a6e;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 28px;
    font-size: 12px;
}

.banner-upload {
    flex: 0 0 180px;
}

.banner-link {
    flex: 1;
    min-width: 260px;
}

.banner-actions {
    flex: 0 0 auto;
}
</style>
